export default __webpack_public_path__ + "static/media/recycle.588c4ef8.svg";